module.exports = __webpack_public_path__ + "img/transparent.fbfb43db.png";